/******************************************************
 *                  Open-iti import
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("OpenImportsCtrl", [
		"$scope", "toastr", "Utils", "$uibModal", "OpenImportsService", "$controller", "AdminClientsService", "AdminImportConfigurationService", "$location", "$timeout"
		,function ($scope, toastr, Utils, $uibModal, OpenImportsService, $controller, AdminClientsService, AdminImportConfigurationService, $location, $timeout) {

		$controller("JobsCtrlParent", {$scope: $scope});

		$scope.data = {
			imports: {},
			importConfigurations: []
		};

		let refId, timeoutImportData, predefinedImportModal;

		/*
 		* Récupère l'état de tous les imports du référentiel courant
		*/
		let getImportData = function () {
			OpenImportsService.getMobiitiImports(refId).then((response) => {
					$scope.data.imports = response.data.filter(importData => importData.fileName !== null && hasImportProcessInEvents(importData)).sort(reverseFirstEventSorter);
					initImportLists();
					timeoutImportData = $timeout(() => getImportData(), 5000);
				})
				.catch(function () {
					toastr.error("Problème lors de la récupération des imports");
					timeoutImportData = $timeout(() => getImportData(), 5000);
				});
		};

		let hasImportProcessInEvents = function (importData) {
			return importData.events.some(event => event.action.includes('IMPORT'));
		}

		let initImportLists = function () {
			if ($scope.data.imports.length == 0) return;
			$scope.data.firstImport = $scope.data.imports.slice(0, 1);
			let maxNbOfImports = $scope.data.imports.length;
			if ($scope.data.imports.length >= 10) {
				maxNbOfImports = 10
			}
			$scope.data.followingImports = $scope.data.imports.slice(1, maxNbOfImports);
		};

		let reverseFirstEventSorter = function (obj1, obj2) {
			if (obj1.firstEvent > obj2.firstEvent) return -1;
			if (obj1.firstEvent < obj2.firstEvent) return 1;
			return 0;
		};

		AdminClientsService.getReferentialId().then((data) => {
			refId = data;
			getImportData();
		});

		$scope.$on('$destroy', function (e) {
			$timeout.cancel(timeoutImportData);
		});

		/*
 		* Génère l'URL des détails de l'import
 		*/
		$scope.generateImportDetailsUrl = function (imprt) {
			const uttuEvent = imprt.events.find(event => event.action === "IMPORT_UTTU" && event.uttuJobId);
			if (uttuEvent) {
				return "#/data-management/imports/flex/" + uttuEvent.referential + "/" + uttuEvent.uttuJobId;
			}
			const event = imprt.events.find(event => event.action === "IMPORT" && event.chouetteJobId);
			if (event) {
				return "#/data-management/imports/" + event.referential + "/" + event.chouetteJobId;
			}
		};


		$scope.goToLinesPage = function () {
			$location.path("e-iti/reseaux-lignes/");
		};

		$scope.formatLineBreaks = function (inputString) {
			if (inputString == null || inputString === undefined) {
				return " ";
			}

			return inputString.replace("\\n", "\n");
		};

		$scope.selectPredefinedImportToLaunch = function () {
			predefinedImportModal = Utils.openModal($uibModal, "predefinedImportModal.html", $scope);
			AdminImportConfigurationService.getAllImportConfiguration().then((response)=> {
					$scope.data.importConfigurations = response.data;
				})
				.catch(() => {
					toastr.error("Problème lors de la récupération des imports prédéfinis.", "Erreur");
				});
		};

		$scope.launchPredefinedImport = function (selectedPredefinedImport) {
			AdminClientsService.getReferentialIdAndUser().then((referential) => {
				OpenImportsService.importPredefinedImport(referential.id, referential.user, selectedPredefinedImport.id)
					.then(() => {
						toastr.success("Import prédéfini : " + selectedPredefinedImport.name + " lancé.");
						predefinedImportModal.close();
					})
					.catch(() => {
						toastr.error("Problème lors du lancement de l'import prédéfini : " + selectedPredefinedImport.name, "Erreur");
					});
			});
		};

		$scope.getTypeLabel = function (imp) {
			switch (imp.type) {
				case 'GTFS_FULL_FLEX':
					return 'GTFS FLEX';
				case 'GTFS_FLEX':
					return 'GTFS + GTFS FLEX';
				case 'GTFS':
					return imp.isflexible ? 'GTFS + GTFS FLEX' : imp.type;
				default:
					return imp.type;
			}
		};

	}]);
